"use client";
import { useEffect } from "react";
import Script from "next/script";

const CumulusUniversalTracking = () => {
  useEffect(() => {
    // Generate a random order number
    const ordnumber = Math.floor(Math.random() * 10000000000000);

    // Construct tracking URL
    const sscUrl = `https://trkn.us/pixel/conv/ppt=23632;g=airport_home_appliance_catch_all;gid=57611;ord=${ordnumber};v=120`;

    // Check if the pixel is already appended to prevent duplication
    if (!document.getElementById("cumulus-pixel")) {
      const pixelImg = document.createElement("img");
      pixelImg.src = sscUrl;
      pixelImg.alt = "Tracking Pixel";
      pixelImg.width = 1;
      pixelImg.height = 1;
      pixelImg.id = "cumulus-pixel"; // Unique ID to prevent multiple insertions

      document.body.appendChild(pixelImg);
    }
  }, []);

  return (
    <>
      {/* Cumulus SFI Universal Pixel */}
      <Script
        src="https://tag.simpli.fi/sifitag/8f5f7754-0188-4f39-aecf-4cd178365d22"
        strategy="afterInteractive"
        onLoad={() => console.log("Simpli.fi Pixel Loaded")}
        onError={(e) => console.error("Simpli.fi Pixel Failed", e)}
      />
    </>
  );
};

export default CumulusUniversalTracking;
